"use client";

import React, { useState } from "react";
import "./CodeAuditSection.scss";
import Image from "next/image";
import codeAudit from "@/assets/images/services/mobile-app/code-audit.webp";

const CodeAuditSection = ({ codeaudit }) => {
  if (!codeaudit) return null;

  const { title, description, points = [] } = codeaudit;

  const [activeCard, setActiveCard] = useState(points[0]);

  return (
    <section className="code-audit-section">
      <div className="container">
        <div className="audit-top-layout">
          <div className="audit-right-content">
            <div className="audit-main-box">
              <h2>{title}</h2>

              <p>{description}</p>

              <div className="audit-grey-box">
                <Image src={codeAudit} alt="Audit" width={320} height={320} />
              </div>
            </div>
          </div>

          <div className="audit-left-grid">
            {points.map((item) => (
              <div
                key={item.id}
                className={`audit-card ${
                  activeCard?.id === item.id ? "active" : ""
                }`}
                onMouseEnter={() => setActiveCard(item)}
              >
                <div className="icon-box">
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={90}
                    height={90}
                  />
                </div>

                <div className="card-content">
                  <div className="card-title">{item.title}</div>

                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodeAuditSection;
